import { render, staticRenderFns } from "./AllDataCorrectionSubmissions.vue?vue&type=template&id=04849cba&scoped=true&"
import script from "./AllDataCorrectionSubmissions.vue?vue&type=script&lang=js&"
export * from "./AllDataCorrectionSubmissions.vue?vue&type=script&lang=js&"
import style0 from "./AllDataCorrectionSubmissions.vue?vue&type=style&index=0&id=04849cba&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "04849cba",
  null
  
)

export default component.exports